var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button btn btn-primary",on:{"click":_vm.openDemoGuide}},[_c('div',{staticClass:"demo-guide"},[_vm._v("DEMO GUIDE")]),_c('div',{staticClass:"learn-more"},[_vm._v("Learn more about this demo")])])}
var staticRenderFns = []

export { render, staticRenderFns }